import { createContext, useReducer, useContext } from "react";
import { reducer } from "./reducer";

const DataContext = createContext(null);
export const useData = () => {
    return useContext(DataContext);
};

const DispatchContext = createContext(null);
export const useDispatch = () => {
    return useContext(DispatchContext);
};

export const DataProvider = ({ children }) => {
    const [data, dispatch] = useReducer(reducer, {}, initData);
    return (
        <DataContext.Provider value={data}>
            <DispatchContext.Provider value={dispatch}>
                {children}
            </DispatchContext.Provider>
        </DataContext.Provider>
    );
};

const modalStyle = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
    },
};

const initData = () => {
    return {
        settings: {},
        services: [],
        staff: [],
        staffOptions: [],
        /* keyed by _id, and the only place the client can read a staff
           member's current commission rate -- staffOptions carries names
           alone */
        staffObj: {},
        expenseTypes: [],
        expenseTypeOptions: [],
        /* declared so the Selects that read it have a list to render before
           initData answers, rather than each screen guarding for undefined */
        shopOptions: [],
        /* the Shops screen's table -- built per month, so it arrives from
           getShopReport rather than with the rest of the shop data */
        shopReport: {},
        currentSales: [],
        todayTotals: {},
        monthlySales: [],
        dailySales: [],
        commission: {},
        user: {},
        adminLoggedIn: false,
        adminAlert: {},
        editableService: {},
        userAlert: "",
        adminArea: "Sales",
        modalStyle,
    };
};
